export default function buildSearch ({ place, startDate, endDate }) {
    return {
        place,
        startDate,
        endDate,
    }
}
